export const dbHost: string = 'http://localhost:3035'

export const connectId: string = 'e1022fd8-b139-4026-88b8-4c42ff514ecf'

export const connectOpt: string = 'S4ME'

export const authData: string = 'S4ME_auth_data'